/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TypeOfPay {
    BASE = 'base',
    ACTUAL_BONUS = 'actualBonus',
    ACTUAL_BONUS_PCT = 'actualBonusPct',
    TARGET_BONUS = 'targetBonus',
    TARGET_BONUS_PCT = 'targetBonusPct',
    TARGET_TOTAL_CASH = 'targetTotalCash',
    ACTUAL_TOTAL_CASH = 'actualTotalCash',
    TARGET_TOTAL_DIRECT = 'targetTotalDirect',
    ACTUAL_TOTAL_DIRECT = 'actualTotalDirect',
    LTI_ACTUAL = 'ltiActual',
    LTI_ACTUAL_PCT = 'ltiActualPct',
    FIXED_COMP = 'fixedComp',
    TOTAL_ALLOWANCES = 'totalAllowances',
    LTI_TARGET = 'ltiTarget',
    LTI_TARGET_PCT = 'ltiTargetPct',
    LTI_NEW_HIRE_ACTUAL = 'ltiNewHireActual',
    LTI_NEW_HIRE_TARGET = 'ltiNewHireTarget',
    SALES_INCENTIVE_ACTUAL = 'salesIncentiveActual',
    SALES_INCENTIVE_PCT_ACTUAL = 'salesIncentivePctActual',
    SALES_INCENTIVE_TARGET = 'salesIncentiveTarget',
    SALES_INCENTIVE_PCT_TARGET = 'salesIncentivePctTarget',
    SALES_COMMISSION_PAID_ACTUAL = 'salesCommissionPaidActual',
    SALES_COMMISSION_TARGET_PCT = 'salesCommissionTargetPct',
    ANNUAL_BASE = 'annualBase',
    TRANSPORTATION_ALLOWANCE = 'transportationAllowance',
    HOUSING_ALLOWANCE = 'housingAllowance',
    MEAL_ALLOWANCE = 'mealAllowance',
    EDUCATION_ALLOWANCE = 'educationAllowance',
    JOB_SKILL_ALLOWANCE = 'jobSkillAllowance',
    LANGUAGE_ALLOWANCE = 'languageAllowance',
    LEAVE_TRAVEL_ALLOWANCE = 'leaveTravelAllowance',
    TELECOMMUNICATION_PHONE_ALLOWANCE = 'telecommunicationPhoneAllowance',
    CAR_ALLOWANCE = 'carAllowance',
}
